import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import web5 from "../img/teasale.jpg";
import "../style/styles.css";
import "../style/Teasale.css";

const TeaSale = () => {
  const quickStats = [
    { value: "Billing", label: "Tea Sales" },
    { value: "Blend", label: "Tea Blending" },
    { value: "Lot", label: "Lot Wise Stock" },
    { value: "GST", label: "Accounts & Returns" },
  ];

  const coreModules = [
    {
      title: "Entry Module",
      text:
        "Manage factory invoice arrival, outside purchase, inter godown transfer, warehouse transfer, blending, delivery order, sales advice, GST sales, auction billing, export sales and voucher entries.",
    },
    {
      title: "Tea Blending",
      text:
        "Control tea blending process with blend number, lot number, grade, warehouse stock, blending issue, blending receipt and blending register reports.",
    },
    {
      title: "Warehouse & Lot Stock",
      text:
        "Track warehouse-wise tea stock, lot-no-wise tea stock, grade-wise stock, arrival-wise stock, tea category stock, closing stock and stock ledger.",
    },
    {
      title: "MIS Reports",
      text:
        "Generate factory invoice, transit invoice, stock transfer, purchase, delivery, sales advice, invoice, export, auction, withdrawn and blending registers.",
    },
    {
      title: "Outstanding Reports",
      text:
        "Monitor debtor balance, creditor balance, debtor/creditor ageing and bill-by-bill ageing analysis for better collection control.",
    },
    {
      title: "Accounting & GST Reports",
      text:
        "Generate cash bank book, journal book, debit note, credit note, purchase, sales, ledger, trial balance, expense trial, GST sales and GSTR reports.",
    },
  ];

  const entryFeatures = [
    "Arrival Entry - Factory Invoice",
    "Purchase from Outside of Garden",
    "Inter Godown Transfer",
    "Warehouse Wise Tea Stock Transfer",
    "Tea Blending Entry",
    "Blend Number Wise Entry",
    "Lot Number Wise Tea Stock Entry",
    "Delivery Order",
    "Sales Advice",
    "Tea Withdrawn",
    "GST General Sales Invoice",
    "Auction and Private Auction Billing",
    "Export Sales",
    "Excess",
    "Shortage",
    "Miscellaneous Purchase Entry",
    "Purchase - Service",
    "GST Reverse Entry",
    "Receipt",
    "Payment",
    "Contra",
    "Journal",
    "Debit Note",
    "Credit Note",
    "Voucher Manage Confirmation",
  ];

  const misReports = [
    "Factory Invoice Register",
    "Transit Invoice Register",
    "Inward Stock Transfer Reports",
    "Outward Stock Transfer Reports",
    "Warehouse Wise Stock Transfer Register",
    "Purchase Register - Goods and Services",
    "Delivery Register",
    "Sales Advice Register",
    "Invoice Register - General / Private GST Sale",
    "Export Invoice Register",
    "Invoice - Accounts Sale Register",
    "Overall Sales Register",
    "Auction Sales Register - IRN by Tea Board",
    "Sales Return Register",
    "Tea Withdrawn Register",
    "Inter Godown Transfer Register",
    "Purchase Register - Tea",
    "Tea Blending Register",
    "Blend Number Wise Register",
    "LOT Query",
    "Lot Number Wise Stock Register",
    "Grade Wise Average Register",
  ];

  const stockReports = [
    "Stock Summary - Overall",
    "Closing Stock - Overall with Valuation",
    "Stock Summary - Grade Wise",
    "Stock Summary - Warehouse Wise",
    "Stock Summary - Lot Wise",
    "Stock Summary - Lot Number Wise",
    "Stock Summary - Tea Category",
    "Stock Summary - Arrival Wise",
    "Closing Stock - Grade Wise",
    "Closing Stock - Warehouse Wise",
    "Closing Stock - Lot Wise",
    "Closing Stock - Lot Number Wise",
    "Closing Stock - Tea Category",
    "Closing Stock - Arrival Wise",
    "Stock Ledger",
    "Warehouse Wise Stock Ledger",
    "Lot Number Wise Stock Ledger",
    "Closing Stock Export to Excel for Blending Import",
  ];

  const accountingReports = [
    "Cash Bank Book",
    "Journal Book",
    "Debit Note Register",
    "Credit Note Register",
    "Purchase Register",
    "Purchase Return Register",
    "Sales Register",
    "Sales Return Register",
    "Ledger",
    "Trial Balance",
    "Expense Trial",
    "Trading and Profit & Loss Statement",
    "Bank Reconciliation",
    "Interest Calculation",
    "Confirmation of Accounts",
    "Statement of Expenditure",
    "Cost Centre Reports",
    "GST Type Wise Sales Register",
    "GSTR-I, GSTR-II and GSTR-3B Reports",
  ];

  const outstandingReports = [
    "Debtor's Balance Summary",
    "Aging Analysis - Debtors / Creditors",
    "Creditor's Balance Summary",
    "Aging Analysis - Bill by Bill",
  ];

  const seoKeywords = [
    "TeaSale Tea Trading Software",
    "Tea Trader Software",
    "Tea Trading Software",
    "Tea Manufacturer Software",
    "Tea Manufacturing Software",
    "Tea Manufacturer Billing Software",
    "Tea Sales Software",
    "Tea Billing Software",
    "Tea GST Billing Software",
    "Tea Inventory Software",
    "Tea Stock Management Software",
    "Tea Warehouse Stock Software",
    "Warehouse Wise Tea Stock Software",
    "Lot No Wise Tea Stock Software",
    "Lot Number Wise Tea Stock Software",
    "Tea Lot Stock Software",
    "Tea Grade Wise Stock Software",
    "Tea Category Wise Stock Software",
    "Tea Arrival Wise Stock Software",
    "Tea Closing Stock Software",
    "Tea Stock Ledger Software",
    "Tea Blending Software",
    "Tea Blending Management Software",
    "Blend Number Wise Tea Software",
    "Tea Blend Register Software",
    "Tea Auction Sales Software",
    "Private Auction Billing Software",
    "Tea Export Sales Software",
    "Tea Delivery Order Software",
    "Tea Sales Advice Software",
    "Tea Purchase Software",
    "Tea Purchase Register Software",
    "Tea Transit Invoice Software",
    "Factory Invoice Register Software",
    "Tea MIS Report Software",
    "Tea Accounting Software",
    "Tea Outstanding Software",
    "Tea Debtor Creditor Software",
    "Tea GSTR Software",
    "Tea Business Software in India",
    "Tea Trading Software in India",
    "Tea Software in Siliguri",
    "Tea Software in West Bengal",
  ];

  const relatedSearchGroups = [
    {
      title: "Tea Trading & Manufacturer Software",
      text:
        "TeaSale is designed for tea traders, tea manufacturers and tea businesses that need billing, purchase, sales, stock, MIS, GST and accounting control.",
      terms: [
        "TeaSale Tea Trading Software",
        "Tea Trader Software",
        "Tea Trading Software",
        "Tea Manufacturer Software",
        "Tea Manufacturing Software",
        "Tea Manufacturer Billing Software",
        "Tea Sales Software",
        "Tea Billing Software",
        "Tea GST Billing Software",
        "Tea Business Management Software",
        "Tea Purchase Software",
        "Tea Sales Register Software",
      ],
    },
    {
      title: "Tea Blending & Blend Register",
      text:
        "TeaSale manages tea blending workflow with blend number, tea issue, tea receipt, blending register, lot selection and stock export/import support for blending operations.",
      terms: [
        "Tea Blending Software",
        "Tea Blending Management Software",
        "Blend Number Wise Tea Software",
        "Tea Blend Register Software",
        "Tea Blending Register",
        "Tea Blending Stock Software",
        "Tea Blend Stock Software",
        "Tea Blending Import Software",
        "Tea Blending Export Software",
        "Tea Manufacturing Blending Software",
        "Tea Batch Blending Software",
        "Tea Production Blending Software",
      ],
    },
    {
      title: "Warehouse, Lot No & Grade Wise Stock",
      text:
        "TeaSale provides warehouse-wise tea stock, lot-no-wise tea stock, grade-wise tea stock, tea category stock, arrival-wise stock and closing stock valuation reports.",
      terms: [
        "Tea Inventory Software",
        "Tea Stock Management Software",
        "Tea Warehouse Stock Software",
        "Warehouse Wise Tea Stock Software",
        "Lot No Wise Tea Stock Software",
        "Lot Number Wise Tea Stock Software",
        "Tea Lot Stock Software",
        "Tea Grade Wise Stock Software",
        "Tea Category Wise Stock Software",
        "Tea Arrival Wise Stock Software",
        "Tea Closing Stock Software",
        "Tea Stock Ledger Software",
        "Warehouse Wise Stock Ledger",
        "Lot Wise Stock Ledger",
      ],
    },
    {
      title: "Auction, Sales Advice & Export Sales",
      text:
        "TeaSale supports auction sales, private auction billing, export sales, delivery order, sales advice, withdrawn tea and overall tea sales registers.",
      terms: [
        "Tea Auction Sales Software",
        "Tea Auction Billing Software",
        "Private Auction Billing Software",
        "Tea Export Sales Software",
        "Tea Delivery Order Software",
        "Tea Sales Advice Software",
        "Tea Withdrawn Register Software",
        "Overall Tea Sales Register",
        "Tea Invoice Register Software",
        "Tea Sales Return Software",
        "Tea Board IRN Auction Software",
        "Tea Sales MIS Software",
      ],
    },
    {
      title: "Tea Accounting, GST & Outstanding",
      text:
        "TeaSale includes final accounting, GST reports, debtor and creditor outstanding, ageing analysis, purchase register, sales register, ledger and trial balance.",
      terms: [
        "Tea Accounting Software",
        "Tea GST Software",
        "Tea GSTR Software",
        "Tea GST Sales Register",
        "Tea Purchase Register Software",
        "Tea Sales Register Software",
        "Tea Ledger Software",
        "Tea Trial Balance Software",
        "Tea Debtor Creditor Software",
        "Tea Outstanding Software",
        "Tea Ageing Analysis Software",
        "Tea Cash Bank Book Software",
        "Tea Profit and Loss Software",
        "Tea Final Accounting Software",
      ],
    },
    {
      title: "Tea Software by Location",
      text:
        "TeaSale is useful for tea traders, tea manufacturers, tea warehouses and tea businesses looking for tea billing, blending, lot stock, warehouse stock and accounting software in Siliguri, West Bengal and India.",
      terms: [
        "Tea Business Software in India",
        "Tea Trading Software in India",
        "Tea Manufacturer Software in India",
        "Tea Blending Software in India",
        "Tea Inventory Software in India",
        "Tea Software in Siliguri",
        "Tea Trading Software in Siliguri",
        "Tea Software in West Bengal",
        "Tea Trading Software in West Bengal",
        "Tea Software Company in Siliguri",
        "Tea Software Developer in West Bengal",
        "Tea Business Software in West Bengal",
      ],
    },
  ];

  const seoPainPoints = [
    {
      title: "Tea trader billing and sales control",
      text:
        "TeaSale helps tea traders manage tea billing, delivery order, sales advice, GST invoice, auction sales, private auction billing, export sales and sales registers.",
    },
    {
      title: "Tea blending workflow management",
      text:
        "TeaSale supports blending entries, blend number wise register, tea blending register and stock export/import support for organized blending operations.",
    },
    {
      title: "Warehouse and lot-wise stock accuracy",
      text:
        "TeaSale tracks warehouse-wise tea stock, lot-no-wise tea stock, grade-wise stock, tea category stock, arrival-wise stock and closing stock valuation.",
    },
    {
      title: "Tea accounting and GST reporting",
      text:
        "TeaSale provides purchase register, sales register, cash bank book, ledger, trial balance, outstanding, ageing analysis, GST sales register and GSTR reports.",
    },
  ];

  const faqList = [
    {
      question: "What is TeaSale tea trading software?",
      answer:
        "TeaSale is a tea trading, tea manufacturing, billing, blending, stock and accounting software for tea traders and tea manufacturers.",
    },
    {
      question: "Does TeaSale support warehouse-wise tea stock?",
      answer:
        "Yes. TeaSale supports warehouse-wise stock summary, warehouse-wise closing stock, warehouse transfer, stock ledger and stock valuation reports.",
    },
    {
      question: "Can TeaSale manage lot-no-wise tea stock?",
      answer:
        "Yes. TeaSale manages lot-wise and lot-no-wise tea stock, lot query, lot-wise closing stock, lot-wise stock ledger and tea stock valuation.",
    },
    {
      question: "Does TeaSale support tea blending?",
      answer:
        "Yes. TeaSale supports tea blending entries, blend number wise register, tea blending register and stock export/import support for blending operations.",
    },
    {
      question: "Does TeaSale include GST and accounting reports?",
      answer:
        "Yes. TeaSale includes GST sales register, GSTR-I, GSTR-II, GSTR-3B, purchase register, sales register, ledger, trial balance, outstanding and final accounting reports.",
    },
  ];

  const siteUrl = (process.env.REACT_APP_SITE_URL || "https://ebssoftware.co.in").replace(/\/$/, "");
  const pagePath = "/teasale";
  const pageUrl = `${siteUrl}${pagePath}`;
  const heroImagePath = String(web5 || "");
  const heroImageUrl = heroImagePath.startsWith("http")
    ? heroImagePath
    : `${siteUrl}${heroImagePath.startsWith("/") ? heroImagePath : `/${heroImagePath}`}`;

  const seoTitle =
    "Tea Trading Software | TeaSale Blending, Warehouse Stock, Lot Stock & Accounting";

  const seoDescription =
    "TeaSale is a tea trading and tea manufacturer software for billing, blending, warehouse-wise tea stock, lot-no-wise tea stock, auction sales, GST, accounting and MIS reports.";

  const softwareSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "TeaSale",
    alternateName: "TeaSale Tea Trading and Blending Software",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Windows, Web",
    url: pageUrl,
    image: heroImageUrl,
    description: seoDescription,
    brand: {
      "@type": "Brand",
      name: "TeaSale",
    },
    publisher: {
      "@type": "Organization",
      name: "EBS Software Solution",
      url: siteUrl,
    },
    offers: {
      "@type": "Offer",
      price: "75000",
      priceCurrency: "INR",
      availability: "https://schema.org/InStock",
      description: "1 licence / multi-user TeaSale tea trading software package.",
    },
    featureList: [
      "Tea trading billing",
      "Tea manufacturer billing",
      "Tea blending management",
      "Blend number wise register",
      "Warehouse-wise tea stock",
      "Lot-no-wise tea stock",
      "Grade-wise tea stock",
      "Tea auction sales",
      "Private auction billing",
      "Tea export sales",
      "Tea purchase and sales registers",
      "Tea stock ledger",
      "Tea GST and GSTR reports",
      "Tea accounting and outstanding reports",
    ],
    keywords: seoKeywords.join(", "),
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: siteUrl,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "TeaSale Tea Trading Software",
        item: pageUrl,
      },
    ],
  };

  const handleImageError = (event) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <main className="teasale-detail-page">
      <Helmet>
        <meta charSet="utf-8" />

        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords.join(", ")} />

        <link rel="canonical" href={pageUrl} />

        <meta name="robots" content="index, follow, max-image-preview:large" />
        <meta name="author" content="EBS Software Solution" />
        <meta name="language" content="English" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={heroImageUrl} />
        <meta property="og:site_name" content="EBS Software Solution" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={heroImageUrl} />

        <script type="application/ld+json">
          {JSON.stringify([softwareSchema, faqSchema, breadcrumbSchema])}
        </script>
      </Helmet>

      <section className="teasale-hero">
        <img
          className="teasale-hero-bg"
          src={web5}
          alt="TeaSale tea trading software for blending warehouse wise tea stock lot no wise stock billing GST and accounting"
          onError={handleImageError}
        />
        <div className="teasale-hero-overlay"></div>

        <Container className="teasale-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="teasale-hero-content">
                <div className="teasale-kicker">Tea Trading & Blending Software</div>
                <h1>TeaSale</h1>
                <h2>
                  Tea Trading Software with Blending, Warehouse Stock, Lot Stock & Accounting
                </h2>
                <p>
                  TeaSale is specially developed for tea traders and tea
                  manufacturers to manage tea billing, tea blending, warehouse-wise
                  tea stock, lot-no-wise tea stock, auction sales, export sales,
                  GST accounting and advanced MIS reports from one integrated
                  system.
                </p>

                <div className="teasale-hero-actions">
                  <a href="#teasale-modules" className="teasale-btn teasale-btn-primary">
                    View Features
                  </a>
                  <Link to="/EmailContactForm" className="teasale-btn teasale-btn-outline">
                    Request Demo
                  </Link>
                </div>
              </div>
            </Col>

            <Col lg={5}>
              <div className="teasale-price-card">
                <span>1 Licence / Multi-User</span>
                <strong>₹75,000/- + GST</strong>
                <p>
                  Designed for tea traders, tea manufacturers, tea warehouses,
                  blending, auction sales, GST billing, stock valuation and
                  final accounting.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="teasale-stats-section">
        <Container>
          <Row className="g-3">
            {quickStats.map((item) => (
              <Col lg={3} md={6} key={item.label}>
                <div className="teasale-stat-card">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="teasale-overview-section">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
              <div className="teasale-section-label">Overview</div>
              <h2 className="teasale-section-title">
                Tea trading, blending and lot-wise inventory control in one system
              </h2>
              <p className="teasale-text">
                TeaSale helps tea manufacturers and traders manage arrival
                entries, purchases, godown transfers, warehouse transfers,
                blending, delivery orders, sales advice, GST invoices, auction
                sales and export sales with full accounting integration.
              </p>
              <p className="teasale-text">
                Its advanced report utility helps analyze warehouse-wise stock,
                lot-no-wise stock, grade-wise stock, sales, purchases, blending,
                lots, grades and profitability to improve tea business control
                and decision-making.
              </p>
            </Col>

            <Col lg={6}>
              <div className="teasale-overview-card">
                <h3>TeaSale covers</h3>
                <div className="teasale-overview-grid">
                  <div><span>✓</span><p>Tea Trading</p></div>
                  <div><span>✓</span><p>Tea Blending</p></div>
                  <div><span>✓</span><p>Warehouse Stock</p></div>
                  <div><span>✓</span><p>Lot No Stock</p></div>
                  <div><span>✓</span><p>Auction Sales</p></div>
                  <div><span>✓</span><p>Accounting & GST</p></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="teasale-seo-section">
        <Container>
          <div className="teasale-heading-center">
            <div className="teasale-section-label">Why Tea Traders Choose TeaSale</div>
            <h2 className="teasale-section-title">
              Tea trading software built for blending, warehouse stock, lot stock and GST accounting
            </h2>
            <p>
              TeaSale is designed for tea traders, tea manufacturers and tea
              businesses that need better control over tea billing, blending,
              warehouse-wise tea stock, lot-no-wise tea stock, auction sales,
              export sales, outstanding, GST and final accounting.
            </p>
          </div>

          <Row className="g-4">
            {seoPainPoints.map((item) => (
              <Col lg={3} md={6} key={item.title}>
                <div className="teasale-seo-card">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="teasale-modules-section" id="teasale-modules">
        <Container>
          <div className="teasale-heading-center">
            <div className="teasale-section-label">Key Modules</div>
            <h2 className="teasale-section-title">
              Complete tea sales workflow from arrival to accounts
            </h2>
            <p>
              TeaSale connects arrival, purchase, blending, warehouse stock,
              lot stock, delivery, sales, outstanding and accounting reports in
              one organized platform.
            </p>
          </div>

          <Row className="g-4">
            {coreModules.map((module, index) => (
              <Col lg={4} md={6} key={module.title}>
                <div className="teasale-module-card">
                  <div className="teasale-module-number">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                  <h3>{module.title}</h3>
                  <p>{module.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="teasale-feature-list-section">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="teasale-list-card">
                <div className="teasale-section-label">Entry Module</div>
                <h2>Billing, blending and voucher entries</h2>
                <ul>
                  {entryFeatures.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={6}>
              <div className="teasale-list-card teasale-list-card-dark">
                <div className="teasale-section-label">MIS Reports</div>
                <h2>Registers and business analysis</h2>
                <ul>
                  {misReports.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="teasale-feature-list-section teasale-feature-list-alt">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="teasale-list-card">
                <div className="teasale-section-label">Stock Reports</div>
                <h2>Warehouse, lot, grade and valuation control</h2>
                <ul>
                  {stockReports.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={6}>
              <div className="teasale-list-card">
                <div className="teasale-section-label">Outstanding</div>
                <h2>Debtor, creditor and ageing analysis</h2>
                <ul>
                  {outstandingReports.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="teasale-accounting-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg={5}>
              <div className="teasale-accounting-title">
                <div className="teasale-section-label">Accounting</div>
                <h2 className="teasale-section-title">
                  Final accounting and GST reporting
                </h2>
                <p>
                  TeaSale provides complete accounting reports with purchase,
                  sales, ledger, trial balance, expense trial, statement of
                  expenditure, GST sales registers and GSTR reports.
                </p>
              </div>
            </Col>

            <Col lg={7}>
              <div className="teasale-accounting-grid">
                {accountingReports.map((item) => (
                  <div key={item}>
                    <span>✓</span>
                    <p>{item}</p>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="teasale-faq-section">
        <Container>
          <div className="teasale-heading-center">
            <div className="teasale-section-label">FAQ</div>
            <h2 className="teasale-section-title">
              Questions about TeaSale tea trading software
            </h2>
            <p>
              Important information for tea traders and tea manufacturers looking
              for billing, blending, warehouse stock, lot stock, GST and
              accounting software.
            </p>
          </div>

          <div className="teasale-faq-list">
            {faqList.map((item) => (
              <div className="teasale-faq-item" key={item.question}>
                <h3>{item.question}</h3>
                <p>{item.answer}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      <section className="teasale-cta-section">
        <Container>
          <div className="teasale-cta-card">
            <div>
              <span>Ready to manage tea trading professionally?</span>
              <h2>Use TeaSale for blending, stock, billing and accounting.</h2>
              <p>
                Get a complete tea trading solution for arrival, warehouse stock,
                lot-no-wise stock, auction, blending, stock valuation, GST
                billing and accounting reports.
              </p>
            </div>
            <Link to="/EmailContactForm" className="teasale-btn teasale-btn-light">
              Request Demo
            </Link>
          </div>
        </Container>
      </section>

      <section className="teasale-corporate-keywords-section">
        <Container>
          <div className="teasale-corporate-keywords-head">
            <div className="teasale-section-label">Related Solutions</div>
            <h2>Tea trading, blending, warehouse stock, lot stock and accounting search terms</h2>
            <p>
              TeaSale covers important tea trading and tea manufacturing
              requirements with professional billing, blending, warehouse-wise
              stock, lot-no-wise stock, auction sales, GST, MIS and accounting
              modules.
            </p>
          </div>

          <Row className="g-4">
            {relatedSearchGroups.map((group) => (
              <Col lg={6} key={group.title}>
                <div className="teasale-corporate-keyword-card">
                  <h3>{group.title}</h3>
                  <p>{group.text}</p>

                  <div className="teasale-corporate-keyword-list">
                    {group.terms.map((term) => (
                      <span key={term}>{term}</span>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default TeaSale;